"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }

var _MMSR5JSJcjs = require('./MMSR5JSJ.cjs');




var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');


var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/form/form-store.ts
var _formstore = require('@ariakit/core/form/form-store'); var Core = _interopRequireWildcard(_formstore);
var _react = require('react');
function useFormStoreProps(store, update, props) {
  store = _MMSR5JSJcjs.useCollectionStoreProps.call(void 0, store, update, props);
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "values", "setValues");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "errors", "setErrors");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "touched", "setTouched");
  const useValue = _react.useCallback.call(void 0, 
    (name) => _FH6HQ5JNcjs.useStoreState.call(void 0, store, () => store.getValue(name)),
    [store]
  );
  const useValidate = _react.useCallback.call(void 0, 
    (callback) => {
      callback = _3BSDKDKDcjs.useEvent.call(void 0, callback);
      const items = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "items");
      _react.useEffect.call(void 0, () => store.onValidate(callback), [items, callback]);
    },
    [store]
  );
  const useSubmit = _react.useCallback.call(void 0, 
    (callback) => {
      callback = _3BSDKDKDcjs.useEvent.call(void 0, callback);
      const items = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "items");
      _react.useEffect.call(void 0, () => store.onSubmit(callback), [items, callback]);
    },
    [store]
  );
  return _react.useMemo.call(void 0, 
    () => ({
      ...store,
      useValue,
      useValidate,
      useSubmit
    }),
    [store, useValue, useValidate, useSubmit]
  );
}
function useFormStore(props = {}) {
  const [store, update] = _FH6HQ5JNcjs.useStore.call(void 0, Core.createFormStore, props);
  return useFormStoreProps(store, update, props);
}




exports.useFormStoreProps = useFormStoreProps; exports.useFormStore = useFormStore;
